import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { LocalMenuGroupRouteNames, LocalMenuGroupRoutePathNames } from '../../../../enums';

const Component = () => import('./LocalBrandInsights.vue');

export default {
  path: buildChildURL(LocalMenuGroupRoutePathNames.INSIGHTS),
  name: LocalMenuGroupRouteNames.BRAND_INSIGHTS,
  component: Component,
} as RouteRecordRaw;
